import { Textarea } from '@acpaas-ui/react-components';
import { useState } from 'react';
import Modal from './Modal';
import ModalTitle from './ModalTitle';

const CasetafelRejectModal = ({ isOpen, onClose, onConfirm, isCommission }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [remark, setRemark] = useState('');

  const handleClose = () => {
    setIsSubmitting(false);
    setError('');
    setRemark('');
    onClose();
  };

  const onRejectError = (error) => {
    setError(error);
    setIsSubmitting(false);
  };

  const onRejectSuccess = () => {
    setError('');
    setIsSubmitting(true);
    handleClose();
  };

  const handleConfirm = () => {
    setError('');
    setIsSubmitting(true);
    onConfirm(remark, onRejectError, onRejectSuccess);
  };

  return (
    <Modal
      title={<ModalTitle title={`Niet akkoord gaan met verslag ${isCommission ? 'commissie' : 'casetafel'}`} />}
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmLabel="Niet Akkoord"
      onConfirmIcon="ai-close"
      onConfirmType="danger"
      canConfirm={!!remark}
    >
      <Textarea
        label="Waarom ga je niet akkoord?"
        required
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
      {error && <small className="u-block u-margin-top-sm u-text-danger">{error}</small>}
    </Modal>
  );
};

export default CasetafelRejectModal;
